const menuElement = () => `
    <h3>Menu</h3>
    <div class="food_menu">
        <h4>Makanan:</h4>
          <ol>
          </ol>
    </div>
    <div class="drink_menu">
        <h4>Minuman:</h4>
          <ol>
          </ol>
    </div>
    `;

export default menuElement;
